import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { IndexComponent } from "./index/index.component";
import { ApploginComponent } from "./applogin/applogin.component";
import { AppcustomerlistComponent } from "./appcustomerlist/appcustomerlist.component";
import { AppkycdetailsComponent } from "./appkycdetails/appkycdetails.component";
import { TransactionsComponent } from "./transactions/transactions.component";
import { FiatTransactionsComponent } from "./fiattransactions/transactions.component";
import { LoginactivityComponent } from "./loginactivity/loginactivity.component";
//import { FiatactivityComponent } from "./fiatactivity/fiatactivity.component";
//import { CryptoactivityComponent } from "./cryptoactivity/cryptoactivity.component";
import { AdminTransactionsComponent } from "./admin-transactions/admin-transactions.component";
import { WithdrawComponent } from "./withdraw/withdraw.component";
import { FiatWithdrawComponent } from "./fiatwithdraw/fiatwithdraw.component";
import { OrderComponent } from "./order/order.component";
import { ManageadminComponent } from "./manageadmin/manageadmin.component";
import { GroupsComponent } from "./groups/groups.component";
import { ContentComponent } from "./_layout/content/content.component";
import { AnnouncementComponent } from "./announcement/announcement.component";

import { KycplansComponent } from "./kycplans/kycplans.component";
import { ManageAuctionConfigurationComponent } from "./manage-auction-configuration/manage-auction-configuration.component";
import { ManageipComponent } from './manageip/manageip.component'
import { CmsComponent } from './cms/cms.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { GeneratePasswordComponent } from './generate-password/generate-password.component';
import { ManualkycComponent } from './manualkyc/manualkyc.component';
import { ReferralconfigComponent } from './referralconfig/referralconfig.component';
import { ReferalhistoryComponent } from './referalhistory/referalhistory.component';
import { ReferralbonustransComponent } from './referralbonustrans/referralbonustrans.component';
import { CareersComponent } from "./careers/careers.component";
import { ContentManagementComponent } from "./content-management/content-management.component";
import { CandidatesComponent } from "./candidates/candidates.component";
import { HomeComponent } from "./home/home.component";
import { ManageAddressWhitelistComponent } from "./manage-address-whitelist/manage-address-whitelist.component";
import { LedgerComponent } from "./ledger/ledger.component";
import { ClientOrderReportComponent } from "./clientorderreport/clientorderreport.component";
import { AdminTradeMasterReportComponent } from "./admintrademaster/admintrademaster.component";
import { ClientTradeReportComponent } from "./clienttradereport/clienttradereport.component";
import { FireblockVaultComponent } from "./fireblockvault/fireblockvault.component";
import { FireblockAuditComponent } from "./fireblockaudit/fireblockaudit.component";
import { ExchangeTradeReportComponent } from "./exchangetradereport/exchangetradereport.component";
import { PositionBookComponent } from "./positionbook/positionbook.component";
import { ClearJunctionAuditComponent } from "./clearjunctionaudit/clearjunctionaudit.component";
import { whitelistedAddressComponent } from "./whitelistedAddress/whitelistedaddress.component";
import { depositAddressComponent } from "./deposit-address/deposit-address.component";
import { GetinTouchReportComponent } from "./getintouch/getintouch.component";
import { ClearJunctionTransactionsComponent } from "./clearjunctiontransactions/clearjunctiontransaction.component";
import { FireblockTransactionsComponent } from "./fireblocktransactions/fireblocktransactions.component";
import { FireblockSyncComponent } from "./fireblocksync/fireblocksync.component";
import { ExchangeDepositComponent } from "./exchangedeposit/exchangedeposit.component";
import { ExchangeWithdrawalComponent } from "./exchangewithdrawal/exchangewithdrawal.component";
import { CustomerListComponent } from "./customerlist/customerlist.component";
import { SidebarSubmenuComponent } from "./sidebar-submenu/sidebar-submenu.component";
import { WalletComponent } from "./wallet/wallet.component";
import { BankComponent } from "./bank/bank.component";
import { MarketPricesComponent } from "./marketprices/marketprices.component";
import { CollateralDepositComponent } from "./collateral-deposit/collateral-deposit.component";
import { SumsubAuditComponent } from "./sumsubaudit/sumsubaudit.component";
import { ClientAssetReportComponent } from "./clientassetreport/clientassetreport.component";
import { AMLBotAuditComponent } from "./amlbotaudit/amlbotaudit.component";

import { EquitasBankAuditComponent } from "./equitasbankaudit/equitasbankaudit.component";
import { EquitasBankTransactionsComponent } from "./equitasbanktransactions/equitasbanktransaction.component";

import { IndusindBankAuditComponent } from "./indusindbankaudit/indusindbankaudit.component";
import { IndusindBankTransactionsComponent } from "./indusindbanktransactions/indusindbanktransaction.component";

import { WithdrawBatchComponent } from "./withdraw-batch/withdrawbatch.component";

import { AutoWithdrawalComponent } from "./autowithdrawal/autowithdrawal.component";
import { HypervergeKYCAuditComponent } from "./hypervergekycaudit/hypervergekycaudit.component";

import { SettlementComponent } from "./settlement/settlement.component";
import { LoginLogsComponent } from "./loginlogs/loginlogs.component";

import { EmailValidateAuditComponent } from "./emailvalidateaudit/emailvalidateaudit.component";
import { ClientTransactionsComponent } from "./client-transactions/client-transactions.component";
import { TransactionsReportComponent } from "./transactionsreport/transactionsreport.component";
import { PayoutComponent } from "./payout/payout.component";
import { PayoutOrdersComponent } from "./payout-orders/payout-orders.component";
import { PayoutQuotesComponent } from "./payout-quotes/payout-quotes.component";
import { PayoutCustomersComponent } from "./payout-customers/payout-customers.component";
import { PayoutSettlementsComponent } from "./payout-settlements/payout-settlements.component";
import { OfframpTradesComponent } from "./offramp-trades/offramp-trades.component";
import { OfframpDailySummaryComponent } from "./offramp-daily-summary/offramp-daily-summary.component";
import { OfframpDailyLogComponent } from "./offramp-daily-log/offramp-daily-log.component";
import { OfframpCryptoReceivedComponent } from "./offramp-crypto-received/offramp-crypto-received.component";
import { OfframpDailyReportComponent } from "./offramp-daily-report/offramp-daily-report.component";
import { OfframpMonitorComponent } from "./offramp-monitor/offramp-monitor.component";
import { OfframpClientQuotesComponent } from "./offramp-client-quotes/offramp-client-quotes.component";
import { OfframpExchangeQuotesComponent } from "./offramp-exchange-quotes/offramp-exchange-quotes.component";
import { OfframpClientsComponent } from "./offramp-clients/offramp-clients.component";
import { OfframpExchangesComponent } from "./offramp-exchanges/offramp-exchanges.component";
import { OfframpBanksComponent } from "./offramp-banks/offramp-banks.component";
import { OfframpPayoutRechargesComponent } from "./offramp-payout-recharges/offramp-payout-recharges.component";
import { OfframpExchangeWithdrawalsComponent } from "./offramp-exchange-withdrawals/offramp-exchange-withdrawals.component";
import { OfframpExchangeDepositsComponent } from "./offramp-exchange-deposits/offramp-exchange-deposits.component";
import { OfframpPayoutGatewaysComponent } from "./offramp-payout-gateways/offramp-payout-gateways.component";
import { PayoutTopupComponent } from "./payout-topup/payout-topup.component";
import { PayoutWalletComponent } from "./payout-wallet/payout-wallet.component";
import { PayoutLedgerComponent } from "./payout-ledger/payout-ledger.component";
import { GatewayWalletComponent } from "./gateway-wallet/gateway-wallet.component";
import { GatewayDepositsComponent } from "./gateway-deposits/gateway-deposits.component";
import { PayoutSummaryComponent } from "./payout-Summary/payout-summary.component"
import { OfframpBalanceComponent } from "./offramp-balance/offramp-balance.component";
import { PayoutDailyMetricsComponent } from "./payout-daily-metrics/payout-daily-metrics.component";
import { WebhookResponsesComponent } from "./webhook-responses/webhook-responses.component";
import { PayoutCallbackComponent } from "./payout-callback/payout-callback.component";
import { S3ReportsComponent } from "./s3-reports/s3-reports.component";
import { OfframpAdminConfigComponent } from "./offramp-admin-config/offramp-admin-config.component";
import { OfframpCapitalAllocationComponent } from "./offramp-capital-allocation/offramp-capital-allocation.component";
import { OfframpExpensesComponent } from "./offramp-expenses/offramp-expenses.component";
import { OfframpAddressMappingsComponent } from "./offramp-address-mappings/offramp-address-mappings.component";
import { SecuirtiesComponent } from "./secuirties/secuirties.component";

const routes: Routes = [
  //no layout routes
  { path: "", redirectTo: "/index", pathMatch: "full" },
  { path: "index", component: ApploginComponent },
  { path: "verifyemail/:str", component: ApploginComponent },
  { path: "adminverifydevice/:str", component: ApploginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'generatepassword/:id', component: GeneratePasswordComponent },
  //Site routes goes here
  {
    path: "",
    component: ContentComponent,
    children: [
      { path: "", redirectTo: "/customer", pathMatch: "full" },
      { path: "home", component: IndexComponent },
      { path: "customer", component: AppcustomerlistComponent },
      { path: "submenu", component: SidebarSubmenuComponent },
      { path: "customers", component: CustomerListComponent },
      { path: "transactions", component: TransactionsComponent },
      { path: "fiattransactions", component: FiatTransactionsComponent },
      { path: "kyc/:id", component: AppkycdetailsComponent },
      { path: "customer/view/:id", component: AppcustomerlistComponent },
      { path: "login/activity", component: LoginLogsComponent },
      { path: "security", component: SecuirtiesComponent },
      { path: "login/activity/:id", component: LoginactivityComponent },
      { path: "admin-transactions/:id", component: AdminTransactionsComponent },
      { path: "whitelistedAddress/:id", component: whitelistedAddressComponent },
      { path: "depositAddress/:id", component: depositAddressComponent },
      { path: "wallet/:id", component: WalletComponent },
      { path: "bank/:id", component: BankComponent },
      { path: "ledger/:id", component: LedgerComponent },
      { path: "withdraw", component: WithdrawComponent },
      { path: "fiatwithdraw", component: FiatWithdrawComponent },
      { path: "orders", component: OrderComponent },
      { path: "adminlist", component: ManageadminComponent },
      { path: "market-prices", component: MarketPricesComponent },
      // { path: "adminlist/edit/:id", component: ManageadminComponent },
      { path: "groups", component: GroupsComponent },
      { path: "careers", component: CareersComponent },
      { path: "homecms", component: HomeComponent },
      { path: "cms", component: ContentManagementComponent },
      { path: "candidates/:job_id", component: CandidatesComponent },
      { path: "announcement", component: AnnouncementComponent },
      { path: "auctionConfig", component: ManageAuctionConfigurationComponent },
      { path: "positionbook", component: PositionBookComponent },
      { path: "kycplans", component: KycplansComponent },
      { path: "clientorderreport", component: ClientOrderReportComponent },
      { path: "clientassetreport", component: ClientAssetReportComponent },
      { path: "admintradereport", component: AdminTradeMasterReportComponent },
      { path: "clienttradereport", component: ClientTradeReportComponent },
      { path: "exchangetradereport", component: ExchangeTradeReportComponent },
      { path: "manageips", component: ManageipComponent },
      { path: "contentmgmtsys", component: CmsComponent },
      { path: "userkyc/:id", component: ManualkycComponent },
      { path: "getintouch", component: GetinTouchReportComponent },
      { path: "referalconfig", component: ReferralconfigComponent },
      { path: "referralhistory", component: ReferalhistoryComponent },
      { path: "referralbonustrans", component: ReferralbonustransComponent },
      { path: "AddressWhitelist", component: ManageAddressWhitelistComponent },
      { path: "fireblockvault", component: FireblockVaultComponent },
      { path: "exchangedeposit", component: ExchangeDepositComponent },
      { path: "exchangewithdrawal", component: ExchangeWithdrawalComponent },
      { path: "fireblockaudit", component: FireblockAuditComponent },
      { path: "clearjunctionaudit", component: ClearJunctionAuditComponent },
      { path: "sumsubaudit", component: SumsubAuditComponent },
      { path: "hypervergekycaudit", component: HypervergeKYCAuditComponent },
      { path: "amlbotaudit", component: AMLBotAuditComponent },
      { path: "clearjunctiontransactions", component: ClearJunctionTransactionsComponent },
      { path: "fireblocktransactions", component: FireblockTransactionsComponent },
      { path: "fireblocksyncrequest", component: FireblockSyncComponent },
      { path: "collateral-deposit", component: CollateralDepositComponent },

      { path: "equitasbankaudit", component: EquitasBankAuditComponent },
      { path: "equitasbanktransactions", component: EquitasBankTransactionsComponent },

      { path: "indusindbankaudit", component: IndusindBankAuditComponent },
      { path: "indusindbanktransactions", component: IndusindBankTransactionsComponent },

      { path: "withdraw-batch", component: WithdrawBatchComponent },

      { path: "auto-withdraw", component: AutoWithdrawalComponent },

      { path: "settlement", component: SettlementComponent },

      { path: "email-validate-audit", component: EmailValidateAuditComponent },
      { path: "client-transactions", component: ClientTransactionsComponent },
      { path: "transactions-report", component: TransactionsReportComponent },
      { path: "payouts", component: PayoutComponent },
      { path: "payout-orders", component: PayoutOrdersComponent },
      { path: "payout-quotes", component: PayoutQuotesComponent },
      { path: "payout-customers", component: PayoutCustomersComponent },
      { path: "payout-settlements", component: PayoutSettlementsComponent },
      { path: "offramp-trades", component: OfframpTradesComponent },
      { path: "offramp-client-quotes", component: OfframpClientQuotesComponent },
      { path: "offramp-exchange-quotes", component: OfframpExchangeQuotesComponent },
      { path: "offramp-clients", component: OfframpClientsComponent },
      { path: "offramp-exchanges", component: OfframpExchangesComponent },
      { path: "offramp-banks", component: OfframpBanksComponent },
      { path: "offramp-payout-recharges", component: OfframpPayoutRechargesComponent },
      { path: "offramp-exchange-withdrawals", component: OfframpExchangeWithdrawalsComponent },
      { path: "offramp-exchange-deposits", component: OfframpExchangeDepositsComponent },
      { path: "offramp-payout-gateways", component: OfframpPayoutGatewaysComponent },
      { path: "offramp-daily-summary", component: OfframpDailySummaryComponent },
      { path: "offramp-daily-log", component: OfframpDailyLogComponent },
      { path: "offramp-crypto-received", component: OfframpCryptoReceivedComponent },
      { path: "offramp-daily-report", component: OfframpDailyReportComponent },
      { path: "offramp-monitor", component: OfframpMonitorComponent },
      { path: "payout-topup", component: PayoutTopupComponent },
      { path: "payout-wallet", component: PayoutWalletComponent },
      { path: "payout-ledger", component: PayoutLedgerComponent },
      { path: "gateway-wallet", component: GatewayWalletComponent },
      { path: "gateway-deposits", component: GatewayDepositsComponent },
      { path: "payout-summary", component: PayoutSummaryComponent },
      { path: "offramp-balance", component: OfframpBalanceComponent },
      { path: "payout-daily-metrics", component: PayoutDailyMetricsComponent },
      { path: "webhook-responses", component: WebhookResponsesComponent },
      { path: "payout-callback", component: PayoutCallbackComponent },
      { path: "s3reports", component: S3ReportsComponent },
      { path: "offramp-admin-config", component: OfframpAdminConfigComponent },
      { path: "offramp-capital-allocation", component: OfframpCapitalAllocationComponent },
      { path: "offramp-expenses", component: OfframpExpensesComponent },
      { path: "offramp-address-mappings", component: OfframpAddressMappingsComponent },

    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts